/*/ ## EF.program
//
// When an enrollment_id is available, this will return a JSON with: enrollments related school name,
//program name, and an Array of all sponsorships. Primary sponsorship will be flagged true with the
// primary attribute - which can be called directly with getPrimarySponsorship.() All secondary sponsorships
// (if any) will be in an Array via the getSecondarySponsorships() method. */
(function(EF) {

  var Program = Backbone.Model.extend({
    fileName: 'program.json',
    initialize: function(attributes, options) {
        this.enrollment = options.enrollment;
    },
    url: function() {
        return EF.url('/sdk/enrollments/' + this.enrollment.get('id') +'/' + this.fileName);
    },

    sync: function() {
        //if in local mode just do nothing
        if(EF.options.local && !EF.options.loadCustomizationsRemote) {
            return;
        }
        return Backbone.sync.apply(this, arguments);
    },

    getPrimrySponsorship: function() {
      var primary_sponsorship;
      var sponsorships = this.get('sponsorships');
      for(var i=0; i<sponsorships.length; i++) {
        if(sponsorships[i].primary) {
          return sponsorships[i];
        }
      }
    },

    getSecondarySponsorships: function() {
      var matches = 0;
      var sponsorships = this.get('sponsorships');
      var secondary = [];
      for(var i=0; i<sponsorships.length; i++) {
        if(!sponsorships[i].primary) {
          secondary[matches++] = sponsorships[i];
        }
      }
      return secondary;
    }
  });

  _.extend(EF.Models, {
    Program: Program
  });

}(EF));
